import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "utilities/withRouter";
import { Section } from "@sunwing/components";
import { Button, Checkbox, FormControlLabel, FormHelperText, FormLabel, OutlinedInput, Radio, RadioGroup } from "@mui/material";
import commonUtilities from "utilities/common";
import getSfdc from "services/sfdc/sfdc.service";
import bookingInVoice from "services/invoice/invoice.service";
import "./inVoice.css";
import CancelPopup from "../cancelPopup";
import InvoiceError from "../popups/invoiceError";
import * as actions from "modules/common/store/actions";

class InVoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkbox: "",
            checkboxValid: false,
            selectedCheckBox: 0,
            errorMsg: "",
            isInvoice: false,
            isBooking: false,
            isPayment: false,
            isShowDelete: false,
            ttsBookingNumber: "",
            masterBookingNumber: "",
            showInvoiceError: false,
            apiErrorMessage: "",
            customerLanguage: commonUtilities.getLanguage()
        };
    }

    componentDidMount() {
        this.getLead();
    }

    getLead = async () => {
        if (this.props.currentRoute && this.props.currentRoute?.includes("lead")) {
            let { currentRoute } = this.props.currentRoute;
            currentRoute = this.props.currentRoute?.split("/");
            let leadNumber = currentRoute[2];
            // console.log("Lead", leadNumber);
            if (leadNumber && leadNumber?.length > 0) {
                this.props.showLoadingSpinner(true);
                try {
                    const response = await this.props.dispatch(getSfdc(leadNumber));
                    let { ttsBookingNumber, masterBookingNumber } = this.state;
    
                    const data = structuredClone(response?.payload?.data?.data);
                    ttsBookingNumber = data?.ttsBookingNumber ?? "";
                    masterBookingNumber = data?.masterBookingNumber ?? "";
    
                    this.setState({ ttsBookingNumber, masterBookingNumber });  
                }
                catch (error) {
                    console.error(error);
                }
                this.props.showLoadingSpinner(false);
            }
        }
    };

    handleGeneration = async () => {
        let { isInvoice, isBooking, isPayment } = this.state;
        if (!isInvoice && !isBooking && !isPayment) {
            this.setState({
                errorMsg: this.props.localize("qma-invoice-error-msg")
            });
        }
        else if (isInvoice || isBooking || isPayment) {
            this.props.showLoadingSpinner(true);
            const { sfdc } = this.props;
            const data = sfdc?.data?.data;
            let updatedBookingResponse = structuredClone(sfdc);
            const { language } = data;
            const { leadNumber } = this.props.params;
            const { isInvoice, isBooking, isPayment, ttsBookingNumber, masterBookingNumber } = this.state;
            if (updatedBookingResponse?.data?.data){
                updatedBookingResponse.data.data.ttsBookingNumber = ttsBookingNumber;
                updatedBookingResponse.data.data.masterBookingNumber = masterBookingNumber;
            }
            this.props.dispatch({
                type: "GET_SFDC_SUCCESS",
                payload: updatedBookingResponse
            });


            let payload =
            {
                isInvoice: isInvoice,
                isBookingDetail: isBooking,
                isPayment: isPayment,
                bookings: ttsBookingNumber,
                masterBookings: masterBookingNumber,
                language: language, // English (EN) or French (FR)
                email: null // This will be null for this endpoint.
            };
            
            try {
                const response = await this.props.dispatch(bookingInVoice.getInvoice(payload));
                this.props.showLoadingSpinner(false);

                if (response.type === actions.GET_INVOICE_FAIL) {
                    this.setState({
                        apiErrorMessage: this.props.localize("qma-invoice-dispatch-fail")
                    });
                    this.setShowInvoiceError(true);
                }
                else {
                    if (response.payload?.data?.statusCode === 200) {
                        this.props.navigate(`/lead/${leadNumber}/ViewInvoice`);
                    }
                    else {
                        this.setState({
                            apiErrorMessage: response.payload?.data?.message
                        });
                        this.setShowInvoiceError(true);
                    }
                }
            }
            catch (error) {
                this.props.showLoadingSpinner(false);
            }
        }
    };

    setInvoice = (value) => {
        this.setState({
            isShowDelete: value
        });
    };

    setShowInvoiceError = (value) => {
        this.setState({
            showInvoiceError: value
        });
    };

    cancelInvoice() {
        window.open("about:blank", "_self");
        window.close();

    }

    updateBookingNumbers(value) {
        let { ttsBookingNumber } = this.state;
        ttsBookingNumber = value;
        this.setState({ ttsBookingNumber });

    }

    updateMasterBookingNumbers(value) {
        let { masterBookingNumber } = this.state;
        masterBookingNumber = value;
        this.setState({ masterBookingNumber });

    }

    render() {
        const { sfdc } = this.props;
        const data = sfdc?.data?.data;
        const { isInvoice, isBooking, isPayment, errorMsg, isShowDelete, ttsBookingNumber, customerLanguage, showInvoiceError, apiErrorMessage, masterBookingNumber  } = this.state;
        if (!data) return null;
        const { language  } = data;
        
        const pageInformation = this.props.localize("qma-my-group-vacation-page-information");

        return (
            <Fragment>
                <InvoiceError
                    isShow={showInvoiceError}
                    apiErrorMessage={apiErrorMessage}
                    handleClose={() => this.setShowInvoiceError(false)}
                />

                <CancelPopup
                    isShow={isShowDelete}
                    handleInvoie={() => this.cancelInvoice()}
                    handleCancel={() => this.setInvoice(false)}
                    data="Are you sure you want to Cancel?"
                />
                <div className="row margin-bottom-4x ">
                    <div className="row">
                        <Section>
                            <div className="page-main-container margin-bottom-1x">
                                <div className="page-header-container">
                                    <div className="section-header">
                                        <h1>
                                        Group Invoice
                                        </h1>
                                    </div>
                                    <div className="row margin-bottom-1x">
                                        {commonUtilities.parseHtml(pageInformation)}
                                    </div>
                                </div>
                            </div>
                        </Section>
                        <Section>
                            <div className="row border" data-testid="invoice-container" >
                                <div className="wizard-container">
                                    <div className="row margin-bottom-1x">
                                        <div className="row font-bold" >
                                            <span className="required">
                                                {this.props.localize("qma-group-invoice")}
                                            </span>
                                        </div>
                                        <div className="row">
                                            <FormControlLabel
                                                control={<Checkbox checked={this.state.isInvoice} />}
                                                label={customerLanguage === "en" ? "Invoice" : "Facture"}
                                                onChange={() => this.setState(prev => { return { isInvoice: !prev.isInvoice }; })}
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={this.state.isBooking} />}
                                                label={customerLanguage === "en" ? "Booking details" : "Les détails de réservation"}
                                                onChange={() => this.setState(prev => { return { isBooking: !prev.isBooking }; })}
                                            />
                                            <FormControlLabel
                                                control={<Checkbox checked={this.state.isPayment} />}
                                                label={customerLanguage === "en" ? "Payment summary" : "Résumé de paiement"} 
                                                onChange={() => this.setState(prev => { return { isPayment: !prev.isPayment }; })}
                                            />
                                        </div>

                                        <FormHelperText className="error-msg">
                                            {!isInvoice && !isBooking && !isPayment && errorMsg}
                                        </FormHelperText>
                                    </div>
                                    <div className="row margin-bottom-1x">
                                        <div className="row form-control-wrapper">
                                            <FormLabel>
                                                <span className="required">
                                                    {this.props.localize("qma-booking-numbers")}
                                                </span>
                                            </FormLabel>
                                            <OutlinedInput
                                                fullWidth
                                                name=""
                                                id=""
                                                value={ttsBookingNumber}
                                                aria-describedby=""
                                                disabled={false}
                                                onChange={(e) => this.updateBookingNumbers(e?.target?.value)}
                                            />
                                        </div>
                                        <div className="row">
                                            {this.props.localize("qma-one-or-more-numbers")}
                                        </div>
                                    </div>
                                    <div className="row margin-bottom-1x">
                                        <div className="row form-control-wrapper">
                                            <FormLabel>
                                                {this.props.localize("qma-master-booking-numbers")}
                                            </FormLabel>
                                            <OutlinedInput
                                                fullWidth
                                                name=""
                                                id=""
                                                value={masterBookingNumber}
                                                aria-describedby=""
                                                disabled={false}
                                                onChange={(e) => this.updateMasterBookingNumbers(e?.target?.value)}
                                            />
                                        </div>
                                        <div className="row">
                                            {this.props.localize("qma-one-or-more-numbers")}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="row font-bold margin-bottom">
                                            <span className="required">
                                                {this.props.localize("qma-invoice-language")}
                                            </span>
                                        </div>
                                        <div className="row margin-bottom-2x">
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="code"
                                                onChange={(e) => console.log(e.target.value)}
                                                defaultValue={language}
                                                value={language}
                                                disabled={true}
                                            >
                                                <FormControlLabel value="English" control={<Radio />} label="English" />
                                                <FormControlLabel value="French" control={<Radio />} label="French" />
                                            </RadioGroup>
                                        </div>
                                    </div>
                                    <div className="row margin-bottom">
                                        <Button
                                            // disabled={!this.state.formValid}
                                            data-testid={"generate-invoice-btn"}
                                            onClick={this.handleGeneration}
                                            className="margin-right-1x"
                                            variant="contained">
                                            {this.props.localize("qma-generate-invoice")}
                                        </Button>
                                        <Button
                                            data-testid={"cancel-btn"}
                                            onClick={() => this.setInvoice(true)}
                                            variant="outlined">
                                            {this.props.localize("qma-cancel")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Section>
                    </div>
                </div>
            </Fragment>
        );
    }
}
const mapStateToProps = (state) => ({
    sfdc: state.sfdc,
    inVoice: state.inVoice
});
export default connect(mapStateToProps)(withRouter(InVoice));